module.exports = __webpack_public_path__ + "static/media/stymex-logo.90e5684a.jpg";